import React, { useState } from 'react'
import TinderCard from 'react-tinder-card'
import './style.scss';



const Explore = ({data}) => {
   
  const [lastDirection, setLastDirection] = useState()

  const swiped = (direction, nameToDelete) => {
    console.log('removing: ' + nameToDelete)
    setLastDirection(direction)
  }

  const outOfFrame = (name) => {
    console.log(name + ' left the screen!')
  }

  return (
    <div className="explore d-flex  " style={{flexDirection:'column'}}>
    
     
      <div className='cardContainer'>
        {data.slice(0).reverse().map((character) =>
          <TinderCard className='swipe' key={character.name} onSwipe={(dir) => swiped(dir, character.name)} onCardLeftScreen={() => outOfFrame(character.name)}>
              {console.log(character)}
            <div style={{ backgroundImage: 'url(' + character['profileData']['photoUrl'] + ')' }} className='card'>
              <h3 className="des alert alert-primary" style={{color:'black',fontWeight:'800'}}>{character['profileData']['name']}</h3>
              <div className="d-flex " style={{width:'100%',flexWrap:'wrap'}}>
              {
                  character['profileData']['tags'].map((item)=>{
                      return(
                        <span class="badge bg-soft-success text-success">{item}</span>
                      )
                  })
              }
              <br/>
              
             
              </div>
              <div className="d-flex " style={{width:'100%',flexDirection:'column' ,flexWrap:'wrap',alignItems:'self-end'}}>
              <span class="badge bg-soft-danger text-danger">Match Score : {character['matchScore']}</span>
              </div>
            </div>
          </TinderCard>
        
        )}
          {lastDirection ? <h2 className='infoText' style={{color:'black'}}>Swipe finished</h2> : <h2 className='infoText' />}

      </div>
    
      <button className="btn btn-primary rounded-circle" style={{width:'10%'}}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg></button>
      <br/>
      Like
    </div>
  )
}

export default Explore
